import { map, reduce, head, length } from "../../../fable_modules/fable-library.3.7.20/List.js";
import { SaveStatus_CoalesceSaveStates, SaveStatus } from "../../../Global.js";
import { getModalContainer, modal, getModalFooterContainer, getModalBodyContainer } from "../../Modal/Modal.js";
import { getSavePanel } from "../../SavePanel/SavePanel.js";
import { ButtonProps, defaultProps, main } from "../../Button/Button.js";
import * as react from "react";
import { renderWithButtonProps } from "../Standard.js";

function getCoalescedSaveStatus(saveItems) {
    const matchValue = length(saveItems) | 0;
    switch (matchValue) {
        case 0: {
            return new SaveStatus(0);
        }
        case 1: {
            return head(saveItems)[1];
        }
        default: {
            return reduce(SaveStatus_CoalesceSaveStates, map((tuple_1) => tuple_1[1], saveItems));
        }
    }
}

export function render(isOpen, modalSize, headerText, saveItems, confirmButtonText, confirmButtonFn) {
    const modalBodyHtml = getModalBodyContainer(getSavePanel(headerText, saveItems));
    const coalescedSaveStatus = getCoalescedSaveStatus(saveItems);
    const modalFooterHtml = getModalFooterContainer(main(new ButtonProps(confirmButtonText, defaultProps.Content, (arg) => {
        confirmButtonFn(arg);
    }, (coalescedSaveStatus.tag === 3) ? false : ((coalescedSaveStatus.tag === 2) ? false : (coalescedSaveStatus.tag === 1)), defaultProps.Id, coalescedSaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)));
    return modal(isOpen, getModalContainer(modalSize, react.createElement("div", {}, modalBodyHtml, modalFooterHtml)));
}

export function renderAsModalThenSaveState(isOpen, modalSize, headerText, bodyHtml, cancelButtonProps, acceptButtonProps, confirmButtonText, confirmButtonFn, saveItems) {
    const coalescedSaveStatus = getCoalescedSaveStatus(saveItems);
    switch (coalescedSaveStatus.tag) {
        case 1:
        case 3:
        case 2: {
            return render(isOpen, modalSize, headerText, saveItems, confirmButtonText, confirmButtonFn);
        }
        default: {
            return renderWithButtonProps(isOpen, modalSize, headerText, bodyHtml, cancelButtonProps, acceptButtonProps);
        }
    }
}

